import { render } from "./WhatsAppButton.vue?vue&type=template&id=999debec&scoped=true"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=999debec&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-999debec"]])

export default __exports__